import React, { useContext, useEffect, useState } from "react";
import { faStar, faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontIconsCustom, SwitchCustomPro } from "src/components/custom";
import { RestApiClientContext } from "src/hooks/context/pageContext";

import './ActionsCell.sass'

export const ActionsCell = ({ cell, setVisibleDrawer, setHotelId, reload}) => {
  const restApiClient = useContext(RestApiClientContext);
  const [status, setStatus] = useState('')

  const handleActive = async () => {
    if (status === 'loading') return
    setStatus('loading')
    try {
      const res = await restApiClient.updateActiveEstablishment(cell.id, !cell.isActive)
      res && setStatus('success')
      reload()
    } catch(err) {
      console.error(err.message)
      setStatus('error')
    }
  }
  const handleEdit = async () => {
    try {
      await setHotelId(cell.id)
      await setVisibleDrawer(true)
    } catch(err) {
      console.error(err.message)
    }
  }
  return (
    <div className={`actions-cell ${status === 'loading' ? 'disabled' : ''}`}>
      <SwitchCustomPro
        checked={cell.isActive}
        onChange={handleActive}
      />
      <span onClick={handleEdit} className="action-edit">
        <FontIconsCustom icon={faEdit} />
      </span>
    </div>
  );
};
